// This file is generated automatically by `scripts/build/fp.js`. Please, don't change it.
import fn from '../../differenceInCalendarYears/index.js';
import convertToFP from '../_lib/convertToFP/index.js';
var differenceInCalendarYears = convertToFP(fn, 2);
export default differenceInCalendarYears;


//////////////////
// WEBPACK FOOTER
// ./~/date-fns/esm/fp/differenceInCalendarYears/index.js
// module id = 834
// module chunks = 0